// قبل تخریب مپ نمی شود

export const BusinessLineToPhaseMapping = [
    {
        ParentID: 1,
        ParentTitle: "خدمات مهندسی و مشاوره",
        childid: 1001,
        ChildTitle: "طراحی معماری و شهرسازی",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "قبل از جواز",
        recommendedPhaseForBuy: "قبل از جواز",
        recommendedPhaseForExecution: "جواز / تخریب",
        generalRecommendations:
            "عامل کلیدی: رزومه و سبک کاری معمار، خلاقیت، درک نیاز کارفرما و بازار هدف پروژه.<br>توصیه استراتژیک: روی ارزش‌آفرینی از طریق طراحی بهینه (که منجر به فروش بهتر واحدها می‌شود) تمرکز کنید. ارائه رندرهای باکیفیت برگ برنده شماست.",
    },
    {
        ParentID: 1,
        ParentTitle: "خدمات مهندسی و مشاوره",
        childid: 1002,
        ChildTitle: "طراحی و محاسبات سازه",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "قبل از جواز",
        recommendedPhaseForBuy: "قبل از جواز",
        recommendedPhaseForExecution: "فونداسیون / اسکلت",
        generalRecommendations:
            "عامل کلیدی: بهینه‌سازی مصرف فولاد/بتن، دقت در نقشه‌ها، تعهد به آیین‌نامه‌ها (مخصوصا ۲۸۰۰).<br>توصیه استراتژیک: نشان دهید که طرح شما چگونه هزینه‌های ساخت را بدون کاهش ایمنی، کاهش می‌دهد. ارائه نقشه‌های دقیق و بدون نقص (Shop Drawing) مزیت رقابتی است.",
    },
    {
        ParentID: 1,
        ParentTitle: "خدمات مهندسی و مشاوره",
        childid: 1003,
        ChildTitle: "مقاوم‌سازی و بهسازی لرزه‌ای (طراحی)",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "قبل از شروع پروژه",
        recommendedPhaseForBuy: "قبل از شروع پروژه",
        recommendedPhaseForExecution: "حین بازسازی",
        generalRecommendations:
            "عامل کلیدی: رزومه قوی در پروژه‌های مشابه، تسلط کامل بر تکنیک‌های نوین مقاوم‌سازی.<br>توصیه استراتژیک: مشاوره دقیق در مورد هزینه‌-فایده روش‌های مختلف و اخذ تأییدیه‌های لازم از نظام مهندسی، عامل اعتماد سازنده است.",
    },
    {
        ParentID: 1,
        ParentTitle: "خدمات مهندسی و مشاوره",
        childid: 1004,
        ChildTitle: "طراحی تاسیسات مکانیکی",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "قبل از جواز / جواز",
        recommendedPhaseForBuy: "جواز",
        recommendedPhaseForExecution: "اسکلت / دیوارچینی",
        generalRecommendations:
            "عامل کلیدی: طراحی بهینه سیستم (کاهش مصرف انرژی)، انتخاب صحیح تجهیزات، عدم تداخل با معماری و سازه.<br>توصیه استراتژیک: ارائه تحلیل مصرف انرژی و هزینه‌های جاری ساختمان در بلندمدت، شما را از رقبا متمایز می‌کند.",
    },
    {
        ParentID: 1,
        ParentTitle: "خدمات مهندسی و مشاوره",
        childid: 1005,
        ChildTitle: "طراحی تاسیسات الکتریکی",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "قبل از جواز / جواز",
        recommendedPhaseForBuy: "جواز",
        recommendedPhaseForExecution: "اسکلت / دیوارچینی",
        generalRecommendations:
            "عامل کلیدی: رعایت استانداردها و مبحث ۱۳، طراحی بهینه روشنایی، پیش‌بینی نیازهای آینده (مانند شارژ خودرو برقی).<br>توصیه استراتژیک: ارائه راهکارهای هوشمندسازی (BMS) به عنوان یک آپشن جذاب، می‌تواند قرارداد اصلی را تسهیل کند.",
    },
    {
        ParentID: 1,
        ParentTitle: "خدمات مهندسی و مشاوره",
        childid: 1006,
        ChildTitle: "طراحی نما",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "جواز",
        recommendedPhaseForBuy: "اسکلت‌بندی",
        recommendedPhaseForExecution: "دیوارچینی / نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: خلاقیت، همخوانی با طرح معماری، انتخاب متریال مناسب و اجرایی بودن طرح.<br>توصیه استراتژیک: ارائه جزئیات اجرایی دقیق (Detailing) و توانایی نظارت بر اجرای صحیح نما، شما را به یک مشاور قابل اعتماد تبدیل می‌کند.",
    },
    {
        ParentID: 1,
        ParentTitle: "خدمات مهندسی و مشاوره",
        childid: 1007,
        ChildTitle: "نقشه‌برداری (زمینی و هوایی)",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "قبل از جواز / فونداسیون",
        recommendedPhaseForBuy: "قبل از جواز / فونداسیون",
        recommendedPhaseForExecution: "قبل از جواز / فونداسیون",
        generalRecommendations:
            "عامل کلیدی: دقت بسیار بالا، تجهیزات مدرن (توتال استیشن، پهپاد)، سرعت در ارائه نتایج.<br>توصیه استراتژیک: ارائه خدمات جانبی مانند محاسبه احجام خاکی یا پیاده‌سازی دقیق نقاط، ارزش افزوده ایجاد می‌کند.",
    },
    {
        ParentID: 1,
        ParentTitle: "خدمات مهندسی و مشاوره",
        childid: 1008,
        ChildTitle: "مدیریت پیمان و ساخت (MC)",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "جواز",
        recommendedPhaseForBuy: "جواز / تخریب",
        recommendedPhaseForExecution: "در طول کل پروژه",
        generalRecommendations:
            "عامل کلیدی: رزومه قوی، شفافیت مالی، توانایی مدیریت اکیپ‌ها و کنترل زمان‌بندی.<br>توصیه استراتژیک: ارائه یک برنامه پروژه (MSP) دقیق و گزارش‌های منظم پیشرفت، نشان‌دهنده حرفه‌ای بودن شما و عامل اصلی انتخاب است.",
    },
    {
        ParentID: 1,
        ParentTitle: "خدمات مهندسی و مشاوره",
        childid: 1009,
        ChildTitle: "نظارت (عالیه و کارگاهی)",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "جواز",
        recommendedPhaseForBuy: "جواز / تخریب",
        recommendedPhaseForExecution: "در طول کل پروژه",
        generalRecommendations:
            "عامل کلیدی: دقت، حضور مستمر در کارگاه، تسلط بر ضوابط و سخت‌گیری در کنترل کیفیت.<br>توصیه استراتژیک: شما چشم و گوش سازنده در پروژه هستید. تمرکز بر پیشگیری از خطا به جای مچ‌گیری، استراتژی بلندمدت شماست.",
    },
    {
        ParentID: 1,
        ParentTitle: "خدمات مهندسی و مشاوره",
        childid: 1010,
        ChildTitle: "کنترل و مدیریت پروژه",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "جواز",
        recommendedPhaseForBuy: "جواز",
        recommendedPhaseForExecution: "در طول کل پروژه",
        generalRecommendations:
            "عامل کلیدی: تسلط بر نرم‌افزارهای کنترل پروژه (Primavera, MSP)، توانایی تحلیل و ارائه گزارش‌های مدیریتی.<br>توصیه استراتژیک: نشان دهید که چگونه می‌توانید ریسک‌های پروژه را شناسایی و مدیریت کرده و از انحراف بودجه و زمان جلوگیری کنید.",
    },
    {
        ParentID: 1,
        ParentTitle: "خدمات مهندسی و مشاوره",
        childid: 1011,
        ChildTitle: "خدمات آزمایشگاهی (بتن، جوش)",
        saleType: "هر دو",
        recommendedPhaseForSale: "فونداسیون",
        recommendedPhaseForBuy: "فونداسیون",
        recommendedPhaseForExecution: "فونداسیون / اسکلت",
        generalRecommendations:
            "عامل کلیدی: اعتبار و مجوزهای رسمی، دقت و صحت نتایج، سرعت در گزارش‌دهی.<br>توصیه استراتژیک: ارائه خدمات نمونه‌گیری در محل و مشاوره فنی در صورت مشاهده نتایج ضعیف، شما را از یک آزمایشگاه صرف به یک مشاور فنی تبدیل می‌کند.",
    },
    {
        ParentID: 1,
        ParentTitle: "خدمات مهندسی و مشاوره",
        childid: 1012,
        ChildTitle: "متره و برآورد",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "قبل از جواز / جواز",
        recommendedPhaseForBuy: "جواز",
        recommendedPhaseForExecution: "قبل از شروع اجرا",
        generalRecommendations:
            "عامل کلیدی: دقت بسیار بالا در محاسبات، تسلط بر فهرست بها و قیمت‌های روز بازار.<br>توصیه استراتژیک: ارائه تحلیل قیمت و سناریوهای مختلف برای کاهش هزینه‌ها، ارزش خدمات شما را چند برابر می‌کند.",
    },
    {
        ParentID: 1,
        ParentTitle: "خدمات مهندسی و مشاوره",
        childid: 1013,
        ChildTitle: "خدمات مشاوره (حقوقی، سرمایه‌گذاری)",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "قبل از جواز",
        recommendedPhaseForBuy: "قبل از جواز",
        recommendedPhaseForExecution: "در طول کل پروژه",
        generalRecommendations:
            "عامل کلیدی: تخصص در حوزه املاک و مستغلات، رزومه موفق، شبکه ارتباطی قوی.<br>توصیه استراتژیک: تمرکز بر ارائه راهکارهای عملی برای حل مشکلات حقوقی (مانند اختلافات با شهرداری یا همسایگان) یا جذب سرمایه.",
    },
    {
        ParentID: 2,
        ParentTitle: "خدمات و تجهیزات فناوری اطلاعات و نرم‌افزار (IT)",
        childid: 1014,
        ChildTitle: "نرم‌افزارهای تخصصی و BMS",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "دیوارچینی",
        recommendedPhaseForBuy: "گچ و خاک",
        recommendedPhaseForExecution: "نازک‌کاری / ظریف‌کاری",
        generalRecommendations:
            'عامل کلیدی: برند معتبر، قابلیت اطمینان، کاربری آسان، خدمات پس از فروش قوی.<br>توصیه استراتژیک: به جای فروش تجهیزات، "تجربه زندگی هوشمند" را بفروشید. ارائه دموهای جذاب و بازدید از پروژه‌های اجرا شده، کلید موفقیت است.',
    },
    {
        ParentID: 2,
        ParentTitle: "خدمات و تجهیزات فناوری اطلاعات و نرم‌افزار (IT)",
        childid: 1015,
        ChildTitle: "سخت‌افزار و زیرساخت شبکه",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "گچ و خاک",
        recommendedPhaseForBuy: "ابتدای نازک‌کاری",
        recommendedPhaseForExecution: "نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: طراحی زیرساخت پایدار و قابل توسعه، استفاده از تجهیزات باکیفیت.<br>توصیه استراتژیک: ارائه یک نقشه جامع شبکه که نیازهای فعلی و آینده (اینترنت اشیاء، BMS) را پوشش دهد، مزیت شماست.",
    },
    {
        ParentID: 2,
        ParentTitle: "خدمات و تجهیزات فناوری اطلاعات و نرم‌افزار (IT)",
        childid: 1016,
        ChildTitle: "سیستم‌های کنترل تردد و هویت",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "نازک‌کاری",
        recommendedPhaseForBuy: "ظریف‌کاری",
        recommendedPhaseForExecution: "ظریف‌کاری",
        generalRecommendations:
            "عامل کلیدی: قابلیت اطمینان، سهولت استفاده، یکپارچگی با سایر سیستم‌ها (مانند آسانسور).<br>توصیه استراتژیک: تمرکز بر امنیت و راحتی ساکنین (مانند سیستم‌های تشخیص چهره یا پلاک‌خوان) می‌تواند جذابیت پروژه را افزایش دهد.",
    },
    {
        ParentID: 2,
        ParentTitle: "خدمات و تجهیزات فناوری اطلاعات و نرم‌افزار (IT)",
        childid: 1017,
        ChildTitle: "خدمات دیجیتال و وب",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "ظریف‌کاری / پایان کار",
        recommendedPhaseForBuy: "پایان کار",
        recommendedPhaseForExecution: "بعد از پایان کار",
        generalRecommendations:
            "عامل کلیدی: طراحی وبسایت/اپلیکیشن جذاب برای پروژه، تولید محتوای حرفه‌ای (عکاسی، تور مجازی).<br>توصیه استراتژیک: ارائه پکیج کامل بازاریابی دیجیتال برای فروش واحدها، شما را به یک شریک استراتژیک برای سازنده تبدیل می‌کند.",
    },
    {
        ParentID: 3,
        ParentTitle: "خدمات کسب‌وکار و مشاوره",
        childid: 1018,
        ChildTitle: "بازاریابی، رویداد و رسانه",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "ظریف‌کاری / پایان کار",
        recommendedPhaseForBuy: "پایان کار",
        recommendedPhaseForExecution: "بعد از پایان کار",
        generalRecommendations:
            "عامل کلیدی: شبکه ارتباطی قوی با مشاوران املاک، ایده‌های خلاقانه برای معرفی پروژه.<br>توصیه استراتژیک: تمرکز بر ساخت برند برای پروژه و سازنده، و ایجاد یک داستان جذاب برای فروش، فراتر از تبلیغات معمولی است.",
    },
    {
        ParentID: 3,
        ParentTitle: "خدمات کسب‌وکار و مشاوره",
        childid: 1019,
        ChildTitle: "خدمات مالی و اداری",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "قبل از جواز",
        recommendedPhaseForBuy: "قبل از جواز",
        recommendedPhaseForExecution: "در طول کل پروژه",
        generalRecommendations:
            "عامل کلیدی: تخصص در امور مالی پروژه‌های ساختمانی، شفافیت، دقت.<br>توصیه استراتژیک: ارائه خدمات مدیریت جریان نقدی (Cash Flow) و بهینه‌سازی مالیاتی، نیاز حیاتی هر سازنده‌ای است.",
    },
    {
        ParentID: 3,
        ParentTitle: "خدمات کسب‌وکار و مشاوره",
        childid: 1020,
        ChildTitle: "خدمات پس از فروش",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "پایان کار",
        recommendedPhaseForBuy: "پایان کار",
        recommendedPhaseForExecution: "بعد از پایان کار",
        generalRecommendations:
            "عامل کلیدی: پاسخگویی سریع، تیم فنی متخصص، سیستم مدون برای پیگیری درخواست‌ها.<br>توصیه استراتژیک: ارائه یک دفترچه گارانتی و خدمات جامع برای ساختمان، اعتبار برند سازنده را به شدت افزایش می‌دهد و یک مزیت فروش است.",
    },
    {
        ParentID: 3,
        ParentTitle: "خدمات کسب‌وکار و مشاوره",
        childid: 1021,
        ChildTitle: "تحقیق و توسعه",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "قبل از جواز",
        recommendedPhaseForBuy: "قبل از جواز",
        recommendedPhaseForExecution: "قبل از جواز",
        generalRecommendations:
            "عامل کلیدی: توانایی تحلیل بازار، شناسایی نیازهای مشتریان آینده، آشنایی با فناوری‌های نوین ساخت.<br>توصیه استراتژیک: ارائه گزارش‌های امکان‌سنجی (Feasibility Study) دقیق برای کمک به تصمیم‌گیری سازنده در مورد شروع یا عدم شروع پروژه.",
    },
    {
        ParentID: 4,
        ParentTitle: "خدمات عمومی و پشتیبانی",
        childid: 1022,
        ChildTitle: "خرید و فروش سوخت و ضایعات",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "تخریب / در طول پروژه",
        recommendedPhaseForBuy: "بر اساس نیاز",
        recommendedPhaseForExecution: "بر اساس نیاز",
        generalRecommendations:
            "عامل کلیدی: قیمت مناسب (برای ضایعات)، تحویل به موقع (برای سوخت).<br>توصیه استراتژیک: ایجاد یک رابطه بلندمدت و قابل اعتماد برای تبدیل شدن به تأمین‌کننده ثابت پروژه‌های سازنده.",
    },
    {
        ParentID: 4,
        ParentTitle: "خدمات عمومی و پشتیبانی",
        childid: 1023,
        ChildTitle: "خدمات نظافتی و نگهداری",
        saleType: "هر دو",
        recommendedPhaseForSale: "پایان کار",
        recommendedPhaseForBuy: "پایان کار",
        recommendedPhaseForExecution: "بعد از پایان کار",
        generalRecommendations:
            "عامل کلیدی: کیفیت کار، تعهد، استفاده از تجهیزات مناسب.<br>توصیه استراتژیک: ارائه پکیج‌های نگهداری سالانه برای مشاعات ساختمان، یک جریان درآمدی پایدار برای شما و آسودگی خیال برای هیئت مدیره ساختمان است.",
    },
    {
        ParentID: 4,
        ParentTitle: "خدمات عمومی و پشتیبانی",
        childid: 1024,
        ChildTitle: "خدمات هنری و دکوراتیو",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "ظریف‌کاری",
        recommendedPhaseForBuy: "ظریف‌کاری",
        recommendedPhaseForExecution: "ظریف‌کاری / پایان کار",
        generalRecommendations:
            "عامل کلیدی: خلاقیت، نمونه کار قوی، درک فضای معماری.<br>توصیه استراتژیک: همکاری با طراحان داخلی برای ارائه آثار هنری (مجسمه، تابلو) که بخشی از هویت ساختمان شود.",
    },
    {
        ParentID: 4,
        ParentTitle: "خدمات عمومی و پشتیبانی",
        childid: 1025,
        ChildTitle: "خدمات نصب و اجرا",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "بر اساس محصول",
        recommendedPhaseForBuy: "بر اساس محصول",
        recommendedPhaseForExecution: "بر اساس محصول",
        generalRecommendations:
            "عامل کلیدی: تخصص در نصب محصول خاص، دقت، سرعت، تمیزی کار.<br>توصیه استراتژیک: تبدیل شدن به تیم نصب مورد تأیید (Authorized Installer) برای برندهای معتبر، اعتبار شما را افزایش می‌دهد.",
    },
    {
        ParentID: 4,
        ParentTitle: "خدمات عمومی و پشتیبانی",
        childid: 1026,
        ChildTitle: "خدمات عمومی (غیر ساختمانی)",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "بر اساس نیاز",
        recommendedPhaseForBuy: "بر اساس نیاز",
        recommendedPhaseForExecution: "بر اساس نیاز",
        generalRecommendations:
            "عامل کلیدی: پاسخگویی سریع، قیمت مناسب.<br>توصیه استراتژیک: تمرکز بر یک حوزه خاص (مانند پذیرایی در رویدادها) و ارائه خدمات باکیفیت.",
    },
    {
        ParentID: 4,
        ParentTitle: "خدمات عمومی و پشتیبانی",
        childid: 1027,
        ChildTitle: "ساخت و تولید سفارشی",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "بر اساس نیاز",
        recommendedPhaseForBuy: "بر اساس نیاز",
        recommendedPhaseForExecution: "بر اساس نیاز",
        generalRecommendations:
            "عامل کلیدی: توانایی تولید دقیق بر اساس نقشه، کیفیت ساخت، تحویل به موقع.<br>توصیه استراتژیک: تخصص در یک حوزه خاص (مانند سازه‌های فلزی دکوراتیو یا مبلمان خاص) شما را بی‌رقیب می‌کند.",
    },
    {
        ParentID: 5,
        ParentTitle: "پیمانکاری و خدمات اجرایی",
        childid: 1028,
        ChildTitle: "تخریب - گودبرداری",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "جواز",
        recommendedPhaseForBuy: "جواز",
        recommendedPhaseForExecution: "تخریب - گودبرداری",
        generalRecommendations:
            "عامل کلیدی: رعایت اصول ایمنی، سرعت عمل، داشتن ماشین‌آلات مناسب.<br>توصیه استراتژیک: ارائه پکیج کامل شامل تخریب، گودبرداری و پایدارسازی، کار را برای سازنده راحت‌تر می‌کند.",
    },
    {
        ParentID: 5,
        ParentTitle: "پیمانکاری و خدمات اجرایی",
        childid: 1029,
        ChildTitle: "نیلینگ و پایدارسازی گود",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "جواز",
        recommendedPhaseForBuy: "تخریب - گودبرداری",
        recommendedPhaseForExecution: "تخریب - گودبرداری",
        generalRecommendations:
            "عامل کلیدی: تخصص فنی بسیار بالا، رزومه قوی، بیمه‌نامه معتبر.<br>توصیه استراتژیک: این حوزه فقط با اعتماد ساخته می‌شود. تمرکز بر ایمنی و ارائه مستندات فنی کامل، تنها راه موفقیت است.",
    },
    {
        ParentID: 5,
        ParentTitle: "پیمانکاری و خدمات اجرایی",
        childid: 1030,
        ChildTitle: "اجرای فونداسیون",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "تخریب - گودبرداری",
        recommendedPhaseForBuy: "تخریب - گودبرداری",
        recommendedPhaseForExecution: "فونداسیون",
        generalRecommendations:
            "عامل کلیدی: تیم آرماتوربند و قالب‌بند ماهر، سرعت عمل، اجرای دقیق طبق نقشه.<br>توصیه استراتژیک: ارائه یک برنامه زمان‌بندی دقیق و پایبندی به آن، مهم‌ترین عامل برای سازنده است زیرا کل پروژه به این مرحله وابسته است.",
    },
    {
        ParentID: 5,
        ParentTitle: "پیمانکاری و خدمات اجرایی",
        childid: 1031,
        ChildTitle: "اجرای اسکلت بتنی",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "فونداسیون",
        recommendedPhaseForBuy: "فونداسیون",
        recommendedPhaseForExecution: "اسکلت‌بندی",
        generalRecommendations:
            "عامل کلیدی: تجهیزات کافی (قالب، جک)، تیم اجرایی ماهر، سرعت در اجرای طبقات.<br>توصیه استراتژیک: کیفیت بتن نهایی (نمایان یا اکسپوز) و اجرای دقیق و گونیای ستون‌ها، نشان‌دهنده توانمندی شماست.",
    },
    {
        ParentID: 5,
        ParentTitle: "پیمانکاری و خدمات اجرایی",
        childid: 1032,
        ChildTitle: "اجرای اسکلت فلزی (جوشی، پیچ و مهره)",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "فونداسیون",
        recommendedPhaseForBuy: "فونداسیون",
        recommendedPhaseForExecution: "اسکلت‌بندی",
        generalRecommendations:
            "عامل کلیدی: کیفیت ساخت در کارخانه، دقت در نصب، تیم اجرایی ایمن و سریع.<br>توصیه استراتژیک: برای سازه‌های پیچ و مهره، ارائه دفترچه محاسباتی دقیق (Shop Drawing) و کنترل کیفیت در کارخانه، عامل کلیدی اعتماد است.",
    },
    {
        ParentID: 5,
        ParentTitle: "پیمانکاری و خدمات اجرایی",
        childid: 1033,
        ChildTitle: "مقاوم‌سازی و بهسازی لرزه‌ای (اجرا)",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "قبل از شروع پروژه",
        recommendedPhaseForBuy: "قبل از شروع پروژه",
        recommendedPhaseForExecution: "حین بازسازی",
        generalRecommendations:
            "عامل کلیدی: تیم اجرایی متخصص و آموزش‌دیده، اجرای دقیق طبق طرح مصوب.<br>توصیه استراتژیک: مستندسازی تصویری مراحل اجرا و ارائه گزارش‌های منظم، به کارفرما اطمینان خاطر می‌دهد.",
    },
    {
        ParentID: 5,
        ParentTitle: "پیمانکاری و خدمات اجرایی",
        childid: 1034,
        ChildTitle: "اجرای سقف (تیرچه، عرشه فولادی، دال)",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "اسکلت‌بندی",
        recommendedPhaseForBuy: "اسکلت‌بندی",
        recommendedPhaseForExecution: "اسکلت‌بندی",
        generalRecommendations:
            "عامل کلیدی: سرعت عمل، رعایت استانداردها، هماهنگی با تیم سازه.<br>توصیه استراتژیک: برای سقف عرشه فولادی، ارائه پکیج کامل (ورق، گلمیخ، اجرا) جذابیت بیشتری دارد.",
    },
    {
        ParentID: 5,
        ParentTitle: "پیمانکاری و خدمات اجرایی",
        childid: 1035,
        ChildTitle: "دیوارچینی و سفت‌کاری",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "اسکلت‌بندی",
        recommendedPhaseForBuy: "اسکلت‌بندی",
        recommendedPhaseForExecution: "دیوارچینی",
        generalRecommendations:
            "عامل کلیدی: سرعت، اجرای دقیق و شاقول، کیفیت دیوار (عدم وجود شکم).<br>توصیه استراتژیک: ارائه قیمت بر اساس متر مربع تمام شده و تضمین کیفیت کار، شما را از پیمانکاران روزمزد متمایز می‌کند.",
    },
    {
        ParentID: 5,
        ParentTitle: "پیمانکاری و خدمات اجرایی",
        childid: 1036,
        ChildTitle: "اجرای نمای خشک (کامپوزیت، سرامیک خشک)",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "دیوارچینی",
        recommendedPhaseForBuy: "گچ و خاک",
        recommendedPhaseForExecution: "نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: تیم نصب بسیار متخصص، اجرای دقیق زیرسازی، آب‌بندی کامل.<br>توصیه استراتژیک: ارائه گارانتی اجرا و آب‌بندی، مهم‌ترین عامل فروش در این حوزه است. رزومه قوی و بازدید از پروژه‌ها ضروری است.",
    },
    {
        ParentID: 5,
        ParentTitle: "پیمانکاری و خدمات اجرایی",
        childid: 1037,
        ChildTitle: "اجرای نمای ملاتی (سنگ، آجر، سیمان)",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "دیوارچینی",
        recommendedPhaseForBuy: "گچ و خاک",
        recommendedPhaseForExecution: "نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: استادکار ماهر، اجرای تمیز و دقیق، سرعت عمل.<br>توصیه استراتژیک: برای سنگ، مهارت در اسکوپ کردن و برای آجر، بندکشی یکنواخت و تمیز، کیفیت کار شما را نشان می‌دهد.",
    },
    {
        ParentID: 5,
        ParentTitle: "پیمانکاری و خدمات اجرایی",
        childid: 1038,
        ChildTitle: "اجرای نمای شیشه‌ای (کرتین وال، فریم لس)",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "دیوارچینی",
        recommendedPhaseForBuy: "گچ و خاک",
        recommendedPhaseForExecution: "نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: تخصص فنی بالا، اجرای دقیق پروفیل‌ها، آب‌بندی بی‌نقص.<br>توصیه استراتژیک: این یک کار مهندسی است، نه پیمانکاری ساده. ارائه محاسبات دقیق و ضمانت‌نامه آب‌بندی، الزامی است.",
    },
    {
        ParentID: 5,
        ParentTitle: "پیمانکاری و خدمات اجرایی",
        childid: 1039,
        ChildTitle: "گچ‌کاری و سفیدکاری",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "دیوارچینی",
        recommendedPhaseForBuy: "گچ و خاک",
        recommendedPhaseForExecution: "گچ و خاک",
        generalRecommendations:
            "عامل کلیدی: کیفیت گچ و خاک (بدون موج)، اجرای گونیای نبش‌ها، سطح نهایی صاف و آماده برای نقاشی.<br>توصیه استراتژیک: سرعت و تحویل کار در زمان مقرر، برای هماهنگی با سایر اکیپ‌های نازک‌کاری بسیار حیاتی است.",
    },
    {
        ParentID: 5,
        ParentTitle: "پیمانکاری و خدمات اجرایی",
        childid: 1040,
        ChildTitle: "کاشی‌کاری و سرامیک",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "ابتدای نازک‌کاری",
        recommendedPhaseForBuy: "ابتدای نازک‌کاری",
        recommendedPhaseForExecution: "نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: استادکار ماهر، اجرای تراز و هم‌سطح، بندکشی دقیق و یکنواخت.<br>توصیه استراتژیک: مهارت در کار با ابعاد بزرگ (اسلب) و برش‌های فارسی دقیق، تخصص شما را نشان می‌دهد.",
    },
    {
        ParentID: 5,
        ParentTitle: "پیمانکاری و خدمات اجرایی",
        childid: 1041,
        ChildTitle: "سنگ‌کاری (کف و دیوار)",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "ابتدای نازک‌کاری",
        recommendedPhaseForBuy: "ابتدای نازک‌کاری",
        recommendedPhaseForExecution: "نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: مهارت در انتخاب و چیدمان سنگ (بوک‌مچ)، اجرای دقیق و بدون درز، ساب باکیفیت در انتها.<br>توصیه استراتژیک: سنگ‌کاری یک هنر است. ارائه نمونه کار قوی و توانایی اجرای طرح‌های پیچیده، شما را متمایز می‌کند.",
    },
    {
        ParentID: 5,
        ParentTitle: "پیمانکاری و خدمات اجرایی",
        childid: 1042,
        ChildTitle: "اجرای تاسیسات مکانیکی (لوله کشی)",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "دیوارچینی",
        recommendedPhaseForBuy: "گچ و خاک",
        recommendedPhaseForExecution: "گچ و خاک",
        generalRecommendations:
            "عامل کلیدی: اجرای دقیق طبق نقشه، تست فشار و آب‌بندی، سرعت عمل.<br>توصیه استراتژیک: ارائه مستندات تست و نقشه‌های ازبیلت (As-Built)، نشان‌دهنده حرفه‌ای بودن و تضمین‌کننده کیفیت کار شماست.",
    },
    {
        ParentID: 5,
        ParentTitle: "پیمانکاری و خدمات اجرایی",
        childid: 1043,
        ChildTitle: "اجرای تاسیسات الکتریکی (سیم کشی)",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "گچ و خاک",
        recommendedPhaseForBuy: "گچ و خاک",
        recommendedPhaseForExecution: "ابتدای نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: اجرای دقیق طبق نقشه، رعایت استانداردها، کابل‌کشی تمیز و اصولی.<br>توصیه استراتژیک: ارائه مشاوره برای بهینه‌سازی و پیش‌بینی نیازهای آینده (مانند برق هوشمند)، ارزش کار شما را بالا می‌برد.",
    },
    {
        ParentID: 5,
        ParentTitle: "پیمانکاری و خدمات اجرایی",
        childid: 1044,
        ChildTitle: "اجرای سیستم‌های هوشمند (BMS)",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "گچ و خاک",
        recommendedPhaseForBuy: "ابتدای نازک‌کاری",
        recommendedPhaseForExecution: "نازک‌کاری / ظریف‌کاری",
        generalRecommendations:
            "عامل کلیدی: تیم اجرایی متخصص و آموزش‌دیده، هماهنگی با سایر تیم‌های تاسیسات.<br>توصیه استراتژیک: شما مجری یک سیستم پیچیده هستید. تمرکز بر تحویل یک سیستم یکپارچه و بدون خطا، و آموزش کامل به کاربر نهایی، ضروری است.",
    },
    {
        ParentID: 5,
        ParentTitle: "پیمانکاری و خدمات اجرایی",
        childid: 1045,
        ChildTitle: "نقاشی و پوشش‌های دکوراتیو",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "نازک‌کاری",
        recommendedPhaseForBuy: "ظریف‌کاری",
        recommendedPhaseForExecution: "ظریف‌کاری",
        generalRecommendations:
            "عامل کلیدی: کیفیت زیرسازی، اجرای تمیز و یکدست، مهارت در تکنیک‌های خاص (پتینه، میکروسمنت).<br>توصیه استراتژیک: ارائه آلبوم نمونه کار قوی و توانایی اجرای طرح‌های خاص، شما را از نقاشان معمولی متمایز می‌کند.",
    },
    {
        ParentID: 5,
        ParentTitle: "پیمانکاری و خدمات اجرایی",
        childid: 1046,
        ChildTitle: "اجرای کف سازی",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "نازک‌کاری",
        recommendedPhaseForBuy: "نازک‌کاری",
        recommendedPhaseForExecution: "نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: اجرای تراز و دقیق، رعایت شیب‌بندی در فضاهای خیس.<br>توصیه استراتژیک: تخصص در کف‌سازی‌های نوین (مانند اپوکسی یا بتن پولیشی) می‌تواند بازار جدیدی برای شما ایجاد کند.",
    },
    {
        ParentID: 5,
        ParentTitle: "پیمانکاری و خدمات اجرایی",
        childid: 1047,
        ChildTitle: "اجرای سقف و دیوار کاذب و کناف",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "گچ و خاک",
        recommendedPhaseForBuy: "ابتدای نازک‌کاری",
        recommendedPhaseForExecution: "نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: اجرای دقیق زیرسازی، تحویل سطح صاف و بدون ترک، مهارت در اجرای طرح‌های دکوراتیو.<br>توصیه استراتژیک: سرعت و تمیزی در اجرا، دو عامل کلیدی برای سازنده است تا پروژه نازک‌کاری سریع‌تر پیش برود.",
    },
    {
        ParentID: 5,
        ParentTitle: "پیمانکاری و خدمات اجرایی",
        childid: 1048,
        ChildTitle: "عایق‌کاری (رطوبتی، حرارتی، صوتی)",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "دیوارچینی",
        recommendedPhaseForBuy: "گچ و خاک",
        recommendedPhaseForExecution: "گچ و خاک / نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: اجرای دقیق و اصولی، رعایت جزئیات (مانند همپوشانی‌ها).<br>توصیه استراتژیک: ارائه ضمانت‌نامه کتبی برای اجرا (مخصوصا عایق رطوبتی)، اعتماد سازنده را جلب می‌کند.",
    },
    {
        ParentID: 5,
        ParentTitle: "پیمانکاری و خدمات اجرایی",
        childid: 1049,
        ChildTitle: "جوشکاری و برشکاری",
        saleType: "هر دو",
        recommendedPhaseForSale: "بر اساس نیاز",
        recommendedPhaseForBuy: "بر اساس نیاز",
        recommendedPhaseForExecution: "بر اساس نیاز",
        generalRecommendations:
            "عامل کلیدی: کیفیت جوش، سرعت، تجهیزات مناسب.<br>توصیه استراتژیک: تمرکز بر یک حوزه تخصصی (مانند جوشکاری تاسیسات یا اجرای وال‌پست) و ارائه خدمات باکیفیت.",
    },
    {
        ParentID: 5,
        ParentTitle: "پیمانکاری و خدمات اجرایی",
        childid: 1050,
        ChildTitle: "نجاری و نصابی",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "نازک‌کاری",
        recommendedPhaseForBuy: "ظریف‌کاری",
        recommendedPhaseForExecution: "ظریف‌کاری",
        generalRecommendations:
            "عامل کلیدی: دقت در اندازه‌گیری و برش، نصب تمیز و دقیق.<br>توصیه استراتژیک: مهارت در نصب محصولات خاص (مانند درب‌ها، کابینت، پارکت) شما را به یک متخصص مورد نیاز تبدیل می‌کند.",
    },
    {
        ParentID: 5,
        ParentTitle: "پیمانکاری و خدمات اجرایی",
        childid: 1051,
        ChildTitle: "بازسازی و نوسازی ساختمان",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "قبل از شروع",
        recommendedPhaseForBuy: "قبل از شروع",
        recommendedPhaseForExecution: "کل دوره بازسازی",
        generalRecommendations:
            "عامل کلیدی: توانایی مدیریت پروژه، ارائه ایده‌های خلاقانه، پایبندی به بودجه و زمان.<br>توصیه استراتژیک: شفافیت در ارائه قیمت‌ها و گزارش کار منظم، مهم‌ترین عامل اعتماد در پروژه‌های بازسازی است.",
    },
    {
        ParentID: 5,
        ParentTitle: "پیمانکاری و خدمات اجرایی",
        childid: 1052,
        ChildTitle: "حمل و نقل و خدمات لجستیک",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "بر اساس نیاز",
        recommendedPhaseForBuy: "بر اساس نیاز",
        recommendedPhaseForExecution: "بر اساس نیاز",
        generalRecommendations:
            "عامل کلیدی: سرعت، تعهد، داشتن ماشین‌آلات مناسب (جرثقیل، کامیون).<br>توصیه استراتژیک: ارائه خدمات بسته‌بندی شده (مانند حمل و تخلیه مصالح در طبقات) می‌تواند ارزش افزوده ایجاد کند.",
    },
    {
        ParentID: 6,
        ParentTitle: "مصالح ساختمانی",
        childid: 1053,
        ChildTitle: "سیمان، گچ و مصالح پودری",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "بر اساس نیاز",
        recommendedPhaseForBuy: "بر اساس نیاز",
        recommendedPhaseForExecution: "بر اساس نیاز",
        generalRecommendations:
            "عامل کلیدی: قیمت، تاریخ تولید تازه، تحویل سریع.<br>توصیه استراتژیک: ارائه خدمات حمل به طبقات و تبدیل شدن به تأمین‌کننده ثابت و قابل اعتماد پروژه‌ها.",
    },
    {
        ParentID: 6,
        ParentTitle: "مصالح ساختمانی",
        childid: 1054,
        ChildTitle: "شن، ماسه و پوکه",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "بر اساس نیاز",
        recommendedPhaseForBuy: "بر اساس نیاز",
        recommendedPhaseForExecution: "بر اساس نیاز",
        generalRecommendations:
            "عامل کلیدی: کیفیت و دانه‌بندی مواد، قیمت، تحویل سریع و با حجم دقیق.<br>توصیه استراتژیک: ارائه مشاوره در مورد نوع مصالح برای کاربردهای مختلف (مانند پوکه برای شیب‌بندی).",
    },
    {
        ParentID: 6,
        ParentTitle: "مصالح ساختمانی",
        childid: 1055,
        ChildTitle: "بتن آماده و افزودنی‌ها",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "تخریب - گودبرداری",
        recommendedPhaseForBuy: "فونداسیون / اسکلت بتنی",
        recommendedPhaseForExecution: "فونداسیون / اسکلت بتنی",
        generalRecommendations:
            "عامل کلیدی: کیفیت و عیار بتن، تحویل به موقع و بدون وقفه، پمپ مناسب.<br>توصیه استراتژیک: خوش‌قولی در زمان‌بندی ارسال تراک‌ها، مهم‌ترین عامل برای جلوگیری از اتلاف وقت و هزینه در روز بتن‌ریزی است.",
    },
    {
        ParentID: 6,
        ParentTitle: "مصالح ساختمانی",
        childid: 1056,
        ChildTitle: "آجر، سفال و بلوک (سیمانی، لیکا، هبلکس)",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "اسکلت‌بندی",
        recommendedPhaseForBuy: "دیوارچینی",
        recommendedPhaseForExecution: "دیوارچینی",
        generalRecommendations:
            "عامل کلیدی: کیفیت (ابعاد دقیق، عدم شوره)، قیمت، ظرفیت تأمین بالا.<br>توصیه استراتژیک: برای بلوک‌های نوین (مانند هبلکس)، ارائه آموزش و پشتیبانی فنی در محل، یک مزیت رقابتی قوی است.",
    },
    {
        ParentID: 6,
        ParentTitle: "مصالح ساختمانی",
        childid: 1057,
        ChildTitle: "تیرچه و بلوک سقفی",
        saleType: "هر دو",
        recommendedPhaseForSale: "اسکلت‌بندی",
        recommendedPhaseForBuy: "اسکلت‌بندی",
        recommendedPhaseForExecution: "اسکلت‌بندی",
        generalRecommendations:
            "عامل کلیدی: کیفیت ساخت (رعایت استانداردها)، تحویل به موقع.<br>توصیه استراتژیک: توانایی تولید سفارشی بر اساس نقشه‌های سازه و تحویل سریع، شما را از تولیدکنندگان انبوه متمایز می‌کند.",
    },
    {
        ParentID: 6,
        ParentTitle: "مصالح ساختمانی",
        childid: 1058,
        ChildTitle: "وال پست و وال مش",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "دیوارچینی",
        recommendedPhaseForBuy: "دیوارچینی",
        recommendedPhaseForExecution: "دیوارچینی",
        generalRecommendations:
            "عامل کلیدی: رعایت ضوابط پیوست ششم آیین‌نامه ۲۸۰۰، کیفیت ساخت، سهولت در نصب.<br>توصیه استراتژیک: ارائه مشاوره فنی و جزئیات اجرایی صحیح، به سازنده اطمینان می‌دهد که محصول شما تأییدیه‌های لازم را کسب خواهد کرد.",
    },
    {
        ParentID: 6,
        ParentTitle: "مصالح ساختمانی",
        childid: 1059,
        ChildTitle: "فوم و یونولیت",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "اسکلت‌بندی",
        recommendedPhaseForBuy: "اسکلت‌بندی",
        recommendedPhaseForExecution: "اسکلت‌بندی",
        generalRecommendations:
            "عامل کلیدی: چگالی (دانسیته)، کندسوز بودن، ابعاد دقیق.<br>توصیه استراتژیک: تأکید بر کندسوز بودن و ارائه مستندات آن، با توجه به سخت‌گیری‌های آتش‌نشانی، یک عامل فروش کلیدی است.",
    },
    {
        ParentID: 6,
        ParentTitle: "مصالح ساختمانی",
        childid: 1060,
        ChildTitle: "فوم بتن و لایت فرم",
        saleType: "هر دو",
        recommendedPhaseForSale: "اسکلت‌بندی",
        recommendedPhaseForBuy: "دیوارچینی",
        recommendedPhaseForExecution: "گچ و خاک",
        generalRecommendations:
            "عامل کلیدی: کیفیت فوم، اجرای تراز و یکنواخت، سرعت بالا.<br>توصیه استراتژیک: این محصول ترکیبی از مواد و اجراست. تضمین کیفیت سطح نهایی و عدم نشست، مهم‌ترین دغدغه سازنده است.",
    },
    {
        ParentID: 6,
        ParentTitle: "مصالح ساختمانی",
        childid: 1061,
        ChildTitle: "مصالح پیش‌ساخته بتنی",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "جواز",
        recommendedPhaseForBuy: "اسکلت‌بندی",
        recommendedPhaseForExecution: "دیوارچینی",
        generalRecommendations:
            "عامل کلیدی: کیفیت ساخت در کارخانه، دقت در ابعاد، حمل و نصب ایمن.<br>توصیه استراتژیک: تمرکز بر سرعت بخشیدن به پروژه به کمک قطعات پیش‌ساخته، مهم‌ترین مزیت رقابتی شماست.",
    },
    {
        ParentID: 6,
        ParentTitle: "مصالح ساختمانی",
        childid: 1062,
        ChildTitle: "عایق‌های رطوبتی (ایزوگام، نانو)",
        saleType: "هر دو",
        recommendedPhaseForSale: "دیوارچینی",
        recommendedPhaseForBuy: "گچ و خاک",
        recommendedPhaseForExecution: "گچ و خاک / نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: برند معتبر، استاندارد، گارانتی محصول.<br>توصیه استراتژیک: برای محصولات نانو، ارائه نمونه‌های اجرایی و ضمانت‌نامه کتبی، عامل اصلی اعتماد و فروش است.",
    },
    {
        ParentID: 6,
        ParentTitle: "مصالح ساختمانی",
        childid: 1063,
        ChildTitle: "عایق‌های حرارتی و صوتی (پشم سنگ، فوم)",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "دیوارچینی",
        recommendedPhaseForBuy: "گچ و خاک",
        recommendedPhaseForExecution: "گچ و خاک",
        generalRecommendations:
            "عامل کلیدی: دانسیته و ضخامت دقیق، تأییدیه‌های فنی، نسوز بودن.<br>توصیه استراتژیک: ارائه مشاوره فنی برای انتخاب عایق مناسب بر اساس مبحث ۱۹ مقررات ملی، شما را به یک مشاور تبدیل می‌کند.",
    },
    {
        ParentID: 6,
        ParentTitle: "مصالح ساختمانی",
        childid: 1064,
        ChildTitle: "چسب‌های ساختمانی ، مواد نانو و شیمیایی",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "ابتدای نازک‌کاری",
        recommendedPhaseForBuy: "نازک‌کاری",
        recommendedPhaseForExecution: "نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: برند معتبر، تاریخ تولید، دستورالعمل استفاده شفاف.<br>توصیه استراتژیک: ارائه پشتیبانی فنی و پاسخگویی به سؤالات مجریان، نشان‌دهنده تخصص و اعتبار شماست.",
    },
    {
        ParentID: 6,
        ParentTitle: "مصالح ساختمانی",
        childid: 1065,
        ChildTitle: "تأمین‌کنندگان و کلینیک‌های ساختمانی",
        saleType: "هر دو",
        recommendedPhaseForSale: "در طول کل پروژه",
        recommendedPhaseForBuy: "بر اساس نیاز",
        recommendedPhaseForExecution: "بر اساس نیاز",
        generalRecommendations:
            "عامل کلیدی: تنوع محصولات، قیمت رقابتی، توانایی تأمین سریع.<br>توصیه استراتژیک: ارائه خدمات مشاوره‌ای و پیشنهاد محصولات جایگزین و بهینه، شما را از یک فروشنده صرف به یک شریک برای سازنده تبدیل می‌کند.",
    },
    {
        ParentID: 7,
        ParentTitle: "آهن‌آلات و فولاد",
        childid: 1066,
        ChildTitle: "تیرآهن و میلگرد",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "فونداسیون",
        recommendedPhaseForBuy: "فونداسیون / اسکلت",
        recommendedPhaseForExecution: "فونداسیون / اسکلت",
        generalRecommendations:
            "عامل کلیدی: برند کارخانه (اصالت کالا)، قیمت لحظه‌ای، تحویل سریع.<br>توصیه استراتژیک: ارائه فاکتور رسمی و برگه باسکول دقیق، و ایجاد اعتبار به عنوان یک تأمین‌کننده خوش‌حساب، کلید موفقیت است.",
    },
    {
        ParentID: 7,
        ParentTitle: "آهن‌آلات و فولاد",
        childid: 1067,
        ChildTitle: "پروفیل و قوطی",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "اسکلت‌بندی",
        recommendedPhaseForBuy: "بر اساس نیاز",
        recommendedPhaseForExecution: "بر اساس نیاز",
        generalRecommendations:
            "عامل کلیدی: ضخامت دقیق ورق، کیفیت جوش، ابعاد دقیق.<br>توصیه استراتژیک: موجودی انبار کامل از سایزهای مختلف و تحویل سریع، مزیت رقابتی شماست.",
    },
    {
        ParentID: 7,
        ParentTitle: "آهن‌آلات و فولاد",
        childid: 1068,
        ChildTitle: "نبشی، ناودانی",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "اسکلت‌بندی",
        recommendedPhaseForBuy: "بر اساس نیاز",
        recommendedPhaseForExecution: "بر اساس نیاز",
        generalRecommendations:
            "عامل کلیدی: برند کارخانه، سایز دقیق، قیمت مناسب.<br>توصیه استراتژیک: تبدیل شدن به مرجع تأمین خرده‌باری‌های پروژه در کنار خریدهای اصلی.",
    },
    {
        ParentID: 7,
        ParentTitle: "آهن‌آلات و فولاد",
        childid: 1069,
        ChildTitle: "ورق‌های فولادی (سیاه، گالوانیزه، رنگی)",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "اسکلت‌بندی",
        recommendedPhaseForBuy: "بر اساس نیاز",
        recommendedPhaseForExecution: "بر اساس نیاز",
        generalRecommendations:
            "عامل کلیدی: ضخامت دقیق، کیفیت پوشش (گالوانیزه، رنگ)، قیمت.<br>توصیه استراتژیک: ارائه خدمات جانبی مانند برش و خمکاری، می‌تواند ارزش افزوده ایجاد کند.",
    },
    {
        ParentID: 7,
        ParentTitle: "آهن‌آلات و فولاد",
        childid: 1070,
        ChildTitle: "رابیتس و توری‌های فلزی",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "گچ و خاک",
        recommendedPhaseForBuy: "گچ و خاک",
        recommendedPhaseForExecution: "گچ و خاک",
        generalRecommendations:
            "عامل کلیدی: وزن و تعداد ستون دقیق، کیفیت گالوانیزه (عدم زنگ‌زدگی).<br>توصیه استراتژیک: ارائه محصول باکیفیت و مطابق با مشخصات واقعی، عامل اصلی ایجاد اعتماد است.",
    },
    {
        ParentID: 7,
        ParentTitle: "آهن‌آلات و فولاد",
        childid: 1071,
        ChildTitle: "پیچ و مهره واتصالات",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "اسکلت‌بندی",
        recommendedPhaseForBuy: "اسکلت‌بندی",
        recommendedPhaseForExecution: "اسکلت‌بندی",
        generalRecommendations:
            "عامل کلیدی: گرید و مقاومت پیچ (e.g., 8.8, 10.9)، استاندارد، پوشش مناسب.<br>توصیه استراتژیک: برای سازه‌های پیچ و مهره، ارائه سرتیفیکیت معتبر برای پیچ‌ها الزامی و حیاتی است.",
    },
    {
        ParentID: 7,
        ParentTitle: "آهن‌آلات و فولاد",
        childid: 1072,
        ChildTitle: "لوله‌های فولادی (داربستی، صنعتی)",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "اسکلت‌بندی",
        recommendedPhaseForBuy: "بر اساس نیاز",
        recommendedPhaseForExecution: "بر اساس نیاز",
        generalRecommendations:
            "عامل کلیدی: ضخامت و وزن دقیق، کیفیت جوش درز.<br>توصیه استراتژیک: موجودی کافی و تحویل سریع، مهم‌ترین نیاز سازنده است.",
    },
    {
        ParentID: 8,
        ParentTitle: "ماشین‌آلات، ابزار و تجهیزات",
        childid: 1073,
        ChildTitle: "ماشین‌آلات سنگین و سبک",
        saleType: "هر دو",
        recommendedPhaseForSale: "تخریب / در طول پروژه",
        recommendedPhaseForBuy: "بر اساس نیاز",
        recommendedPhaseForExecution: "بر اساس نیاز",
        generalRecommendations:
            "عامل کلیدی: کیفیت و سلامت دستگاه، قیمت اجاره مناسب، اپراتور ماهر.<br>توصیه استراتژیک: ارائه خدمات اجاره به همراه اپراتور حرفه‌ای و متعهد، دغدغه‌های سازنده را کاهش می‌دهد.",
    },
    {
        ParentID: 8,
        ParentTitle: "ماشین‌آلات، ابزار و تجهیزات",
        childid: 1074,
        ChildTitle: "تجهیزات جوش و برش و ...",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "بر اساس نیاز",
        recommendedPhaseForBuy: "بر اساس نیاز",
        recommendedPhaseForExecution: "بر اساس نیاز",
        generalRecommendations:
            "عامل کلیدی: برند معتبر، کیفیت، خدمات پس از فروش.<br>توصیه استراتژیک: ارائه خدمات اجاره تجهیزات در کنار فروش، می‌تواند بازار جدیدی برای شما ایجاد کند.",
    },
    {
        ParentID: 8,
        ParentTitle: "ماشین‌آلات، ابزار و تجهیزات",
        childid: 1075,
        ChildTitle: "ابزارآلات برقی و شارژی",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "بر اساس نیاز",
        recommendedPhaseForBuy: "بر اساس نیاز",
        recommendedPhaseForExecution: "بر اساس نیاز",
        generalRecommendations:
            "عامل کلیدی: برند معتبر (بوش، ماکیتا)، دوام، گارانتی.<br>توصیه استراتژیک: ایجاد رابطه با سرپرست کارگاه و اکیپ‌های اجرایی برای تبدیل شدن به تأمین‌کننده اصلی ابزار پروژه.",
    },
    {
        ParentID: 8,
        ParentTitle: "ماشین‌آلات، ابزار و تجهیزات",
        childid: 1076,
        ChildTitle: "ابزارآلات دستی و دقیق",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "بر اساس نیاز",
        recommendedPhaseForBuy: "بر اساس نیاز",
        recommendedPhaseForExecution: "بر اساس نیاز",
        generalRecommendations:
            "عامل کلیدی: کیفیت و دوام، در دسترس بودن.<br>توصیه استراتژیک: ارائه پکیج‌های کامل ابزار برای اکیپ‌های مختلف (مانند اکیپ کناف یا تاسیسات).",
    },
    {
        ParentID: 8,
        ParentTitle: "ماشین‌آلات، ابزار و تجهیزات",
        childid: 1077,
        ChildTitle: "تجهیزات ایمنی و کارگاهی و بنایی",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "در طول کل پروژه",
        recommendedPhaseForBuy: "بر اساس نیاز",
        recommendedPhaseForExecution: "بر اساس نیاز",
        generalRecommendations:
            "عامل کلیدی: رعایت استانداردها، کیفیت، در دسترس بودن.<br>توصیه استراتژیک: با توجه به افزایش سخت‌گیری‌ها، تأکید بر استاندارد بودن تجهیزات ایمنی (کلاه، کفش، کمربند) یک مزیت فروش مهم است.",
    },
    {
        ParentID: 9,
        ParentTitle: "تاسیسات مکانیکی",
        childid: 1078,
        ChildTitle: "آسانسور و پله برقی",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "اسکلت‌بندی",
        recommendedPhaseForBuy: "دیوارچینی / گچ و خاک",
        recommendedPhaseForExecution: "نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: برند قطعات اصلی (موتور، تابلو)، رزومه قوی، خدمات پس از فروش پاسخگو.<br>توصیه استراتژیک: فروش آسانسور یک پروسه اعتمادسازی بلندمدت است. بازدید از پروژه‌های نصب شده و ارائه قرارداد سرویس و نگهداری جامع، کلیدی است.",
    },
    {
        ParentID: 9,
        ParentTitle: "تاسیسات مکانیکی",
        childid: 1079,
        ChildTitle: "سیستم‌های سرمایشی (کولر، چیلر، اسپلیت)",
        saleType: "هر دو",
        recommendedPhaseForSale: "دیوارچینی",
        recommendedPhaseForBuy: "گچ و خاک",
        recommendedPhaseForExecution: "نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: مشاوره فنی دقیق، برند معتبر، راندمان انرژی بالا، گارانتی.<br>توصیه استراتژیک: ارائه تحلیل هزینه-فایده بین سیستم‌های مختلف (مانند داکت اسپلیت در مقابل چیلر) و کمک به سازنده برای انتخاب بهینه.",
    },
    {
        ParentID: 9,
        ParentTitle: "تاسیسات مکانیکی",
        childid: 1080,
        ChildTitle: "سیستم‌های گرمایشی (پکیج، رادیاتور، موتورخانه)",
        saleType: "هر دو",
        recommendedPhaseForSale: "دیوارچینی",
        recommendedPhaseForBuy: "گچ و خاک",
        recommendedPhaseForExecution: "نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: برند معتبر، راندمان، خدمات پس از فروش گسترده.<br>توصیه استراتژیک: برای پروژه‌های بزرگ، طراحی و اجرای کامل موتورخانه یک خدمت مهندسی ارزشمند است. برای واحدهای کوچکتر، پکیج‌های کامل (پکیج + رادیاتور) جذاب است.",
    },
    {
        ParentID: 9,
        ParentTitle: "تاسیسات مکانیکی",
        childid: 1081,
        ChildTitle: "تهویه مطبوع (هواساز، فن، داکت)",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "دیوارچینی",
        recommendedPhaseForBuy: "گچ و خاک",
        recommendedPhaseForExecution: "نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: طراحی دقیق و مهندسی، کیفیت ساخت (داکت‌ها)، بی‌صدا بودن سیستم.<br>توصیه استراتژیک: ارائه راهکارهای نوین مانند سیستم‌های بازیابی حرارت (Heat Recovery) برای کاهش مصرف انرژی، شما را متمایز می‌کند.",
    },
    {
        ParentID: 9,
        ParentTitle: "تاسیسات مکانیکی",
        childid: 1082,
        ChildTitle: "لوله و اتصالات (آب، فاضلاب، گاز)",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "دیوارچینی",
        recommendedPhaseForBuy: "گچ و خاک",
        recommendedPhaseForExecution: "گچ و خاک",
        generalRecommendations:
            "عامل کلیدی: برند معتبر و استاندارد، کامل بودن سبد محصولات، درصد تخفیف مناسب.<br>توصیه استراتژیک: تبدیل شدن به تأمین‌کننده جامع تمام لوله‌های پروژه (پنج‌لایه، پوش‌فیت، پلیکا) و ارائه مشاوره فنی.",
    },
    {
        ParentID: 9,
        ParentTitle: "تاسیسات مکانیکی",
        childid: 1083,
        ChildTitle: "شیرآلات و تجهیزات صنعتی",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "گچ و خاک",
        recommendedPhaseForBuy: "ابتدای نازک‌کاری",
        recommendedPhaseForExecution: "نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: برند معتبر (سیم، کیزایران)، کیفیت و استاندارد، تحمل فشار و دما.<br>توصیه استراتژیک: موجودی کامل و توانایی تأمین سریع اقلام موتورخانه، نیاز اصلی پیمانکاران تاسیسات است.",
    },
    {
        ParentID: 9,
        ParentTitle: "تاسیسات مکانیکی",
        childid: 1084,
        ChildTitle: "شیرآلات بهداشتی",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "نازک‌کاری",
        recommendedPhaseForBuy: "ظریف‌کاری",
        recommendedPhaseForExecution: "ظریف‌کاری",
        generalRecommendations:
            "عامل کلیدی: طراحی و زیبایی، کیفیت آبکاری، برند معتبر، گارانتی طولانی‌مدت.<br>توصیه استراتژیک: ارائه ست کامل شیرآلات برای کل پروژه با قیمت رقابتی و نمایش نمونه‌ها در شوروم، عامل اصلی انتخاب است.",
    },
    {
        ParentID: 9,
        ParentTitle: "تاسیسات مکانیکی",
        childid: 1085,
        ChildTitle: "چینی‌آلات و لوازم بهداشتی",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "نازک‌کاری",
        recommendedPhaseForBuy: "ظریف‌کاری",
        recommendedPhaseForExecution: "ظریف‌کاری",
        generalRecommendations:
            "عامل کلیدی: برند، طراحی، کیفیت لعاب (ضد جرم)، سیستم تخلیه بهینه (برای توالت فرنگی).<br>توصیه استراتژیک: ارائه محصولات ست با طراحی هماهنگ و همچنین راهکارهای نوین مانند وال‌هنگ، جذابیت پروژه را افزایش می‌دهد.",
    },
    {
        ParentID: 9,
        ParentTitle: "تاسیسات مکانیکی",
        childid: 1086,
        ChildTitle: "تجهیزات و لوازم جانبی بهداشتی",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "ظریف‌کاری",
        recommendedPhaseForBuy: "ظریف‌کاری",
        recommendedPhaseForExecution: "ظریف‌کاری",
        generalRecommendations:
            "عامل کلیدی: کیفیت، ست بودن با سایر اقلام، دوام.<br>توصیه استراتژیک: ارائه پکیج کامل اکسسوری برای هر واحد، کار را برای سازنده راحت می‌کند.",
    },
    {
        ParentID: 9,
        ParentTitle: "تاسیسات مکانیکی",
        childid: 1087,
        ChildTitle: "پمپ و سیستم‌های آبرسانی",
        saleType: "هر دو",
        recommendedPhaseForSale: "گچ و خاک",
        recommendedPhaseForBuy: "ابتدای نازک‌کاری",
        recommendedPhaseForExecution: "نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: مشاوره و انتخاب صحیح پمپ، برند معتبر، بی‌صدا بودن، گارانتی.<br>توصیه استراتژیک: ارائه پکیج کامل بوسترپمپ (شامل تابلو برق و اینورتر) و تضمین فشار آب استاندارد در تمام طبقات، دغدغه اصلی سازنده را حل می‌کند.",
    },
    {
        ParentID: 9,
        ParentTitle: "تاسیسات مکانیکی",
        childid: 1088,
        ChildTitle: "تجهیزات استخر، سونا و جکوزی",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "دیوارچینی",
        recommendedPhaseForBuy: "گچ و خاک",
        recommendedPhaseForExecution: "نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: مشاوره فنی کامل، برند معتبر تجهیزات، اجرای دقیق و آب‌بندی تضمینی.<br>توصیه استراتژیک: ارائه پکیج کامل طراحی، تأمین تجهیزات و اجرا، و ارائه خدمات نگهداری پس از آن، شما را به یک شریک بلندمدت تبدیل می‌کند.",
    },
    {
        ParentID: 9,
        ParentTitle: "تاسیسات مکانیکی",
        childid: 1089,
        ChildTitle: "سیستم‌های اعلام و اطفاء حریق آبی و گازی",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "دیوارچینی",
        recommendedPhaseForBuy: "گچ و خاک",
        recommendedPhaseForExecution: "نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: داشتن تأییدیه آتش‌نشانی، اجرای دقیق طبق ضوابط، برند معتبر.<brتوصیه استراتژیک: اخذ تأییدیه نهایی از سازمان آتش‌نشانی برای سازنده بسیار حیاتی است. تضمین این موضوع، مهم‌ترین عامل فروش شماست.",
    },
    {
        ParentID: 10,
        ParentTitle: "تاسیسات الکتریکی",
        childid: 1090,
        ChildTitle: "سیم و کابل",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "گچ و خاک",
        recommendedPhaseForBuy: "ابتدای نازک‌کاری",
        recommendedPhaseForExecution: "نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: برند معتبر و استاندارد (اصالت کالا)، خلوص مس، قیمت روز.<br>توصیه استراتژیک: با توجه به وجود کالاهای تقلبی، تأکید بر اصالت کالا و ارائه مستندات آن، کلید ایجاد اعتماد است.",
    },
    {
        ParentID: 10,
        ParentTitle: "تاسیسات الکتریکی",
        childid: 1091,
        ChildTitle: "روشنایی (چراغ، پنل، پروژکتور)",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "نازک‌کاری",
        recommendedPhaseForBuy: "ظریف‌کاری",
        recommendedPhaseForExecution: "ظریف‌کاری",
        generalRecommendations:
            "عامل کلیدی: طراحی زیبا، کیفیت نور (لومن، CRI)، راندمان (وات)، گارانتی معتبر.<br>توصیه استراتژیک: ارائه خدمات طراحی روشنایی به عنوان ارزش افزوده، و نمایش تأثیر نورپردازی بر زیبایی فضا، به فروش کمک می‌کند.",
    },
    {
        ParentID: 10,
        ParentTitle: "تاسیسات الکتریکی",
        childid: 1092,
        ChildTitle: "کلید و پریز",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "نازک‌کاری",
        recommendedPhaseForBuy: "ظریف‌کاری",
        recommendedPhaseForExecution: "ظریف‌کاری",
        generalRecommendations:
            "عامل کلیدی: طراحی و رنگ‌بندی متنوع، کیفیت مکانیزم، کامل بودن سبد محصولات.<br>توصیه استراتژیک: ارائه مدل‌هایی که با سبک‌های مختلف معماری داخلی هماهنگ باشند، یک مزیت رقابتی است.",
    },
    {
        ParentID: 10,
        ParentTitle: "تاسیسات الکتریکی",
        childid: 1093,
        ChildTitle: "تابلو برق و تجهیزات",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "دیوارچینی",
        recommendedPhaseForBuy: "گچ و خاک",
        recommendedPhaseForExecution: "نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: کیفیت مونتاژ، برند معتبر قطعات داخلی، رعایت استانداردها.<br>توصیه استراتژیک: ارائه نقشه‌های فنی دقیق (Shop Drawing) و گارانتی معتبر برای تابلو، نشان‌دهنده حرفه‌ای بودن شماست.",
    },
    {
        ParentID: 10,
        ParentTitle: "تاسیسات الکتریکی",
        childid: 1094,
        ChildTitle: "سیستم‌های اعلام حریق الکتریکی",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "دیوارچینی",
        recommendedPhaseForBuy: "گچ و خاک",
        recommendedPhaseForExecution: "نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: داشتن تأییدیه آتش‌نشانی، برند معتبر، اجرای دقیق و تمیز.<br>توصیه استراتژیک: تضمین اخذ تأییدیه نهایی از سازمان آتش‌نشانی، مهم‌ترین عامل فروش و اعتماد سازنده است.",
    },
    {
        ParentID: 10,
        ParentTitle: "تاسیسات الکتریکی",
        childid: 1095,
        ChildTitle: "دوربین مداربسته و سیستم‌های امنیتی",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "ابتدای نازک‌کاری",
        recommendedPhaseForBuy: "نازک‌کاری",
        recommendedPhaseForExecution: "ظریف‌کاری",
        generalRecommendations:
            "عامل کلیدی: مشاوره در جانمایی، کیفیت تصویر، برند معتبر، خدمات پشتیبانی.<br>توصیه استراتژیک: ارائه پکیج‌های امنیتی کامل (دوربین، دزدگیر، کنترل تردد) به صورت یکپارچه، ارزش بیشتری برای سازنده ایجاد می‌کند.",
    },
    {
        ParentID: 10,
        ParentTitle: "تاسیسات الکتریکی",
        childid: 1096,
        ChildTitle: "آیفون تصویری و آنتن مرکزی",
        saleType: "هر دو",
        recommendedPhaseForSale: "ابتدای نازک‌کاری",
        recommendedPhaseForBuy: "نازک‌کاری",
        recommendedPhaseForExecution: "ظریف‌کاری",
        generalRecommendations:
            "عامل کلیدی: برند معتبر، امکانات (اتصال به دوربین، ارتباط داخلی)، کیفیت تصویر.<br>توصیه استراتژیک: ارائه مدل‌های جدید با قابلیت‌های هوشمند (مانند باز کردن درب با موبایل)، جذابیت پروژه را افزایش می‌دهد.",
    },
    {
        ParentID: 10,
        ParentTitle: "تاسیسات الکتریکی",
        childid: 1097,
        ChildTitle: "سیستم‌های خانه هوشمند (BMS)",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "دیوارچینی",
        recommendedPhaseForBuy: "گچ و خاک",
        recommendedPhaseForExecution: "نازک‌کاری / ظریف‌کاری",
        generalRecommendations:
            'عامل کلیدی: برند معتبر، کاربری آسان، قابلیت اطمینان، خدمات پس از فروش قوی.<br>توصیه استراتژیک: به جای فروش تجهیزات، "تجربه زندگی هوشمند" را بفروشید. ارائه دموهای جذاب و بازدید از پروژه‌های اجرا شده، کلید موفقیت است.',
    },
    {
        ParentID: 10,
        ParentTitle: "تاسیسات الکتریکی",
        childid: 1098,
        ChildTitle: "ژنراتور و برق اضطراری (UPS)",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "اسکلت‌بندی",
        recommendedPhaseForBuy: "دیوارچینی",
        recommendedPhaseForExecution: "نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: مشاوره و محاسبه دقیق توان، برند معتبر، خدمات پس از فروش.<br>توصیه استراتژیک: ارائه پکیج کامل شامل نصب، راه‌اندازی و قرارداد سرویس و نگهداری، دغدغه‌های سازنده را به طور کامل برطرف می‌کند.",
    },
    {
        ParentID: 10,
        ParentTitle: "تاسیسات الکتریکی",
        childid: 1099,
        ChildTitle: "تجهیزات هشدار زلزله",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "نازک‌کاری",
        recommendedPhaseForBuy: "ظریف‌کاری",
        recommendedPhaseForExecution: "ظریف‌کاری",
        generalRecommendations:
            "عامل کلیدی: داشتن تأییدیه‌های فنی، دقت و عدم هشدارهای کاذب.<br>توصیه استراتژیک: با توجه به جدید بودن این فناوری، آموزش و ارائه مستندات فنی کامل، برای جلب اعتماد سازنده ضروری است.",
    },
    {
        ParentID: 10,
        ParentTitle: "تاسیسات الکتریکی",
        childid: 1100,
        ChildTitle: "انرژی‌های تجدیدپذیر (خورشیدی)",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "اسکلت‌بندی",
        recommendedPhaseForBuy: "دیوارچینی",
        recommendedPhaseForExecution: "نازک‌کاری / پایان کار",
        generalRecommendations:
            "عامل کلیدی: مشاوره فنی دقیق، راندمان پنل‌ها، کیفیت اینورتر، رزومه اجرایی.<br>توصیه استراتژیک: ارائه تحلیل بازگشت سرمایه (ROI) و نشان دادن صرفه‌جویی در هزینه‌های بلندمدت، مهم‌ترین عامل برای ترغیب سازنده است.",
    },
    {
        ParentID: 11,
        ParentTitle: "در، پنجره و نما",
        childid: 1101,
        ChildTitle: "پنجره‌های UPVC و آلومینیومی",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "دیوارچینی",
        recommendedPhaseForBuy: "گچ و خاک",
        recommendedPhaseForExecution: "ابتدای نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: کیفیت پروفیل و یراق‌آلات، تولید استاندارد، نصب دقیق و آب‌بندی کامل.<br>توصیه استراتژیک: پنجره شناسنامه نماست. ارائه گارانتی معتبر برای پروفیل، یراق و آب‌بندی، و بازدید از کارخانه تولید، عوامل کلیدی اعتماد هستند.",
    },
    {
        ParentID: 11,
        ParentTitle: "در، پنجره و نما",
        childid: 1102,
        ChildTitle: "درهای داخلی و ورودی (ضد سرقت، چوبی)",
        saleType: "هر دو",
        recommendedPhaseForSale: "گچ و خاک",
        recommendedPhaseForBuy: "ابتدای نازک‌کاری",
        recommendedPhaseForExecution: "نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: زیبایی و طراحی، کیفیت ساخت، امنیت (برای درب ورودی)، یراق‌آلات باکیفیت.<br>توصیه استراتژیک: ارائه طیف وسیعی از مدل‌ها متناسب با سبک‌های مختلف معماری و توانایی تولید سفارشی، مزیت رقابتی است.",
    },
    {
        ParentID: 11,
        ParentTitle: "در، پنجره و نما",
        childid: 1103,
        ChildTitle: "درهای اتوماتیک و کرکره برقی",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "نازک‌کاری",
        recommendedPhaseForBuy: "ظریف‌کاری",
        recommendedPhaseForExecution: "ظریف‌کاری / پایان کار",
        generalRecommendations:
            "عامل کلیدی: برند موتور و اپراتور، بی‌صدا بودن، سرعت و قابلیت اطمینان.<br>توصیه استراتژیک: ارائه گارانتی معتبر و خدمات پس از فروش سریع و در دسترس، مهم‌ترین دغدغه سازنده و ساکنین آینده است.",
    },
    {
        ParentID: 11,
        ParentTitle: "در، پنجره و نما",
        childid: 1104,
        ChildTitle: "شیشه (دوجداره، سکوریت، لمینت)",
        saleType: "هر دو",
        recommendedPhaseForSale: "گچ و خاک",
        recommendedPhaseForBuy: "ابتدای نازک‌کاری",
        recommendedPhaseForExecution: "نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: کیفیت (عدم وجود موج)، تزریق گاز استاندارد، ضخامت دقیق.<br>توصیه استراتژیک: ارائه شیشه‌های خاص مانند لمینت (ایمنی)، سکوریت (مقاومت) یا Low-E (عایق حرارتی)، ارزش افزوده ایجاد می‌کند.",
    },
    {
        ParentID: 11,
        ParentTitle: "در، پنجره و نما",
        childid: 1105,
        ChildTitle: "پروفیل‌های در و پنجره",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "دیوارچینی",
        recommendedPhaseForBuy: "گچ و خاک",
        recommendedPhaseForExecution: "ابتدای نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: برند معتبر، استاندارد، تنوع در مقاطع و رنگ‌ها.<br>توصیه استراتژیک: این فروش معمولاً با کارگاه‌های تولید در و پنجره است. ایجاد رابطه بلندمدت و ارائه خدمات فنی به آنها، کلید موفقیت است.",
    },
    {
        ParentID: 11,
        ParentTitle: "در، پنجره و نما",
        childid: 1106,
        ChildTitle: "یراق‌آلات در و پنجره",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "گچ و خاک",
        recommendedPhaseForBuy: "ابتدای نازک‌کاری",
        recommendedPhaseForExecution: "نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: برند معتبر (ترک، آلمان)، کیفیت و دوام، کارکرد روان.<br>توصیه استراتژیک: ارائه گارانتی تعویض بلندمدت و کامل بودن سبد محصولات، مهم‌ترین مزیت برای تولیدکنندگان در و پنجره است.",
    },
    {
        ParentID: 11,
        ParentTitle: "در، پنجره و نما",
        childid: 1107,
        ChildTitle: "سیستم‌های نمای شیشه‌ای (کرتین وال، اسپایدر)",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "دیوارچینی",
        recommendedPhaseForBuy: "گچ و خاک",
        recommendedPhaseForExecution: "نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: تخصص فنی و مهندسی بالا، اجرای دقیق، آب‌بندی تضمینی.<br>توصیه استراتژیک: این یک خدمت مهندسی است. ارائه محاسبات دقیق سازه و انرژی، و بازدید از پروژه‌های اجرا شده، الزامی است.",
    },
    {
        ParentID: 11,
        ParentTitle: "در، پنجره و نما",
        childid: 1108,
        ChildTitle: "ورق کامپوزیت آلومینیوم",
        saleType: "هر دو",
        recommendedPhaseForSale: "دیوارچینی",
        recommendedPhaseForBuy: "گچ و خاک",
        recommendedPhaseForExecution: "نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: برند ورق، ضد حریق بودن (FR)، ضخامت و کیفیت رنگ.<br>توصیه استراتژیک: ارائه پکیج کامل فروش و اجرا، و تضمین کیفیت نصب و آب‌بندی، کار را برای سازنده راحت‌تر می‌کند.",
    },
    {
        ParentID: 11,
        ParentTitle: "در، پنجره و نما",
        childid: 1109,
        ChildTitle: "پانل‌های سرامیک خشک",
        saleType: "هر دو",
        recommendedPhaseForSale: "دیوارچینی",
        recommendedPhaseForBuy: "گچ و خاک",
        recommendedPhaseForExecution: "نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: برند معتبر، کیفیت، ثبات رنگ، سیستم نصب استاندارد.<br>توصیه استراتژیک: با توجه به نیاز به اجرای تخصصی، همکاری با تیم‌های اجرایی ماهر و ارائه پکیج کامل، مزیت بزرگی است.",
    },
    {
        ParentID: 11,
        ParentTitle: "در، پنجره و نما",
        childid: 1110,
        ChildTitle: "سیستم‌های نمای سنگ خشک",
        saleType: "هر دو",
        recommendedPhaseForSale: "دیوارچینی",
        recommendedPhaseForBuy: "گچ و خاک",
        recommendedPhaseForExecution: "نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: کیفیت سنگ، سیستم نصب استاندارد و مهندسی.<br>توصیه استراتژیک: ارائه مشاوره فنی در مورد انتخاب سنگ مناسب و جزئیات دقیق نصب، شما را از یک فروشنده سنگ به یک متخصص نما تبدیل می‌کند.",
    },
    {
        ParentID: 11,
        ParentTitle: "در، پنجره و نما",
        childid: 1111,
        ChildTitle: "سایر پوشش‌های نما (ترمووود، HPL و ...)",
        saleType: "هر دو",
        recommendedPhaseForSale: "دیوارچینی",
        recommendedPhaseForBuy: "گچ و خاک",
        recommendedPhaseForExecution: "نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: کیفیت متریال، مقاومت در برابر شرایط جوی، رزومه اجرایی.<br>توصیه استراتژیک: ارائه گارانتی معتبر برای ثبات رنگ و دوام محصول، و معرفی تیم‌های اجرایی متخصص، کلید فروش است.",
    },
    {
        ParentID: 12,
        ParentTitle: "پوشش‌های داخلی و خارجی (نازک‌کاری)",
        childid: 1112,
        ChildTitle: "کاشی، سرامیک و پرسلان",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "ابتدای نازک‌کاری",
        recommendedPhaseForBuy: "نازک‌کاری",
        recommendedPhaseForExecution: "نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: طراحی و زیبایی، برند معتبر، کیفیت لعاب، ابعاد دقیق (کالیبره).<br>توصیه استراتژیک: داشتن شوروم جذاب و ارائه نمونه‌های کار شده در ابعاد بزرگ، و همچنین موجودی کافی برای تحویل فوری، بسیار مهم است.",
    },
    {
        ParentID: 12,
        ParentTitle: "پوشش‌های داخلی و خارجی (نازک‌کاری)",
        childid: 1113,
        ChildTitle: "سنگ‌های ساختمانی (نما، کف، پله)",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "اسکلت‌بندی / دیوارچینی",
        recommendedPhaseForBuy: "گچ و خاک",
        recommendedPhaseForExecution: "نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: کیفیت و یکنواختی سورت سنگ، کیفیت فرآوری (ساب، برش).<br>توصیه استراتژیک: امکان بازدید سازنده از انبار و انتخاب مستقیم سنگ (سورت)، مهم‌ترین عامل اعتمادسازی و فروش است.",
    },
    {
        ParentID: 12,
        ParentTitle: "پوشش‌های داخلی و خارجی (نازک‌کاری)",
        childid: 1114,
        ChildTitle: "پارکت، لمینت و کفپوش‌های چوبی",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "نازک‌کاری",
        recommendedPhaseForBuy: "ظریف‌کاری",
        recommendedPhaseForExecution: "ظریف‌کاری",
        generalRecommendations:
            "عامل کلیدی: برند معتبر، ضریب سایش (AC)، کیفیت کلیک‌ها، مقاومت در برابر آب.<br>توصیه استراتژیک: ارائه پکیج کامل محصول و نصب توسط تیم حرفه‌ای، و گارانتی معتبر، دغدغه‌های سازنده را برطرف می‌کند.",
    },
    {
        ParentID: 12,
        ParentTitle: "پوشش‌های داخلی و خارجی (نازک‌کاری)",
        childid: 1115,
        ChildTitle: "کفپوش‌های پلیمری (PVC، اپوکسی)",
        saleType: "هر دو",
        recommendedPhaseForSale: "نازک‌کاری",
        recommendedPhaseForBuy: "ظریف‌کاری",
        recommendedPhaseForExecution: "ظریف‌کاری",
        generalRecommendations:
            "عامل کلیدی: کیفیت متریال، تخصص مجری، سطح نهایی یکدست و زیبا.<br>توصیه استراتژیک: این محصولات به شدت به اجرا وابسته هستند. ارائه ضمانت‌نامه اجرا و نمونه کارهای قوی، ضروری است.",
    },
    {
        ParentID: 12,
        ParentTitle: "پوشش‌های داخلی و خارجی (نازک‌کاری)",
        childid: 1116,
        ChildTitle: "سایر پوشش های کف ( موزاییک،موکت و ...)",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "نازک‌کاری",
        recommendedPhaseForBuy: "ظریف‌کاری",
        recommendedPhaseForExecution: "ظریف‌کاری",
        generalRecommendations:
            "عامل کلیدی: کیفیت، قیمت، تنوع طرح.<br>توصیه استراتژیک: تمرکز بر یک بازار خاص (مثلاً موکت‌های اداری) و ارائه محصولات باکیفیت در آن حوزه.",
    },
    {
        ParentID: 12,
        ParentTitle: "پوشش‌های داخلی و خارجی (نازک‌کاری)",
        childid: 1117,
        ChildTitle: "رنگ و پوشش‌های دکوراتیو",
        saleType: "هر دو",
        recommendedPhaseForSale: "نازک‌کاری",
        recommendedPhaseForBuy: "ظریف‌کاری",
        recommendedPhaseForExecution: "ظریف‌کاری",
        generalRecommendations:
            "عامل کلیدی: برند معتبر، کیفیت و پوشش‌دهی، قابلیت شستشو.<br>توصیه استراتژیک: برای پوشش‌های دکوراتیو، ارائه آلبوم نمونه کار و اجرای یک دیوار به عنوان نمونه در پروژه، بهترین روش فروش است.",
    },
    {
        ParentID: 12,
        ParentTitle: "پوشش‌های داخلی و خارجی (نازک‌کاری)",
        childid: 1118,
        ChildTitle: "کاغذ دیواری و دیوارپوش",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "ظریف‌کاری",
        recommendedPhaseForBuy: "ظریف‌کاری",
        recommendedPhaseForExecution: "ظریف‌کاری",
        generalRecommendations:
            "عامل کلیدی: تنوع طرح، کیفیت و جنس، موجودی انبار.<br>توصیه استراتژیک: ارائه خدمات نصب توسط نصاب حرفه‌ای و تضمین کیفیت نهایی، ارزش خدمات شما را افزایش می‌دهد.",
    },
    {
        ParentID: 12,
        ParentTitle: "پوشش‌های داخلی و خارجی (نازک‌کاری)",
        childid: 1119,
        ChildTitle: "سقف و دیوار کاذب و کناف",
        saleType: "هر دو",
        recommendedPhaseForSale: "گچ و خاک",
        recommendedPhaseForBuy: "ابتدای نازک‌کاری",
        recommendedPhaseForExecution: "نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: برند معتبر متریال، اجرای دقیق و استاندارد، تحویل سطح صاف و آماده نقاشی.<br>توصیه استراتژیک: ارائه پکیج کامل مصالح و اجرا با قیمت رقابتی و تضمین سرعت و کیفیت، نیاز اصلی سازنده است.",
    },
    {
        ParentID: 13,
        ParentTitle: "معماری داخلی و دکوراسیون",
        childid: 1120,
        ChildTitle: "کابینت آشپزخانه",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "نازک‌کاری",
        recommendedPhaseForBuy: "ظریف‌کاری",
        recommendedPhaseForExecution: "ظریف‌کاری",
        generalRecommendations:
            "عامل کلیدی: طراحی خلاقانه و کاربردی، کیفیت متریال (ورق، یراق، صفحه)، اجرای تمیز و دقیق.<br>توصیه استراتژیک: ارائه طراحی سه‌بعدی (3D) باکیفیت و بازدید از نمونه کارهای اجرا شده، مهم‌ترین مراحل فروش هستند. خوش‌قولی در زمان تحویل، اعتبار شما را می‌سازد.",
    },
    {
        ParentID: 13,
        ParentTitle: "معماری داخلی و دکوراسیون",
        childid: 1121,
        ChildTitle: "تجهیزات فرنیش آشپزخانه",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "نازک‌کاری",
        recommendedPhaseForBuy: "ظریف‌کاری",
        recommendedPhaseForExecution: "ظریف‌کاری",
        generalRecommendations:
            "عامل کلیدی: برند معتبر، طراحی هماهنگ (ست)، گارانتی و خدمات پس از فروش.<br>توصیه استراتژیک: ارائه پکیج کامل (هود، گاز، فر، سینک) با قیمت رقابتی، جذابیت زیادی برای سازنده دارد.",
    },
    {
        ParentID: 13,
        ParentTitle: "معماری داخلی و دکوراسیون",
        childid: 1122,
        ChildTitle: "کمد و مصنوعات چوبی",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "نازک‌کاری",
        recommendedPhaseForBuy: "ظریف‌کاری",
        recommendedPhaseForExecution: "ظریف‌کاری",
        generalRecommendations:
            "عامل کلیدی: طراحی بهینه فضای داخلی کمد، کیفیت متریال و ریل‌ها، اجرای تمیز.<br>توصیه استراتژیک: ارائه ایده‌های خلاقانه برای استفاده بهینه از فضا، شما را از یک نجار ساده به یک طراح تبدیل می‌کند.",
    },
    {
        ParentID: 13,
        ParentTitle: "معماری داخلی و دکوراسیون",
        childid: 1123,
        ChildTitle: "اکسسوری",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "ظریف‌کاری",
        recommendedPhaseForBuy: "ظریف‌کاری",
        recommendedPhaseForExecution: "ظریف‌کاری",
        generalRecommendations:
            "عامل کلیدی: کیفیت، زیبایی، هماهنگی با سبک دکوراسیون.<br>توصیه استراتژیک: ارائه پکیج‌های کامل اکسسوری (حمام، آشپزخانه) به طراحان داخلی و سازندگان.",
    },
    {
        ParentID: 13,
        ParentTitle: "معماری داخلی و دکوراسیون",
        childid: 1124,
        ChildTitle: "پارتیشن ، پرده و جداکننده‌ها",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "ظریف‌کاری",
        recommendedPhaseForBuy: "ظریف‌کاری",
        recommendedPhaseForExecution: "پایان کار",
        generalRecommendations:
            "عامل کلیدی: کیفیت، طراحی، هماهنگی با فضا.<br>توصیه استراتژیک: ارائه مشاوره در محل و نمایش نمونه‌ها، به تصمیم‌گیری مشتری کمک می‌کند.",
    },
    {
        ParentID: 13,
        ParentTitle: "معماری داخلی و دکوراسیون",
        childid: 1125,
        ChildTitle: "مبلمان اداری و خانگی",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "پایان کار",
        recommendedPhaseForBuy: "پایان کار",
        recommendedPhaseForExecution: "بعد از پایان کار",
        generalRecommendations:
            "عامل کلیدی: طراحی، ارگونومی، کیفیت ساخت، قیمت.<brتوصیه استراتژیک: همکاری با طراحان داخلی برای ارائه مبلمان به عنوان بخشی از پکیج طراحی، یک کانال فروش مؤثر است.",
    },
    {
        ParentID: 13,
        ParentTitle: "معماری داخلی و دکوراسیون",
        childid: 1126,
        ChildTitle: "نرده و حفاظ",
        saleType: "هر دو",
        recommendedPhaseForSale: "نازک‌کاری",
        recommendedPhaseForBuy: "ظریف‌کاری",
        recommendedPhaseForExecution: "ظریف‌کاری",
        generalRecommendations:
            "عامل کلیدی: زیبایی، استحکام و ایمنی، اجرای تمیز و دقیق.<br>توصیه استراتژیک: ارائه طرح‌های جدید و مدرن (مانند نرده‌های شیشه‌ای) در کنار مدل‌های کلاسیک، بازار شما را گسترش می‌دهد.",
    },
    {
        ParentID: 13,
        ParentTitle: "معماری داخلی و دکوراسیون",
        childid: 1127,
        ChildTitle: "سازه های پیش ساخته",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "جواز",
        recommendedPhaseForBuy: "جواز",
        recommendedPhaseForExecution: "بر اساس نوع سازه",
        generalRecommendations:
            "عامل کلیدی: سرعت ساخت، کیفیت، هزینه تمام شده.<br>توصیه استراتژیک: تمرکز بر یک بازار خاص (مانند ویلاهای پیش‌ساخته یا کیوسک‌ها) و ارائه یک محصول کامل و بی‌دردسر.",
    },
    {
        ParentID: 13,
        ParentTitle: "معماری داخلی و دکوراسیون",
        childid: 1128,
        ChildTitle: "طراحی و ساخت غرفه‌های نمایشگاهی",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "قبل از رویداد",
        recommendedPhaseForBuy: "قبل از رویداد",
        recommendedPhaseForExecution: "قبل از رویداد",
        generalRecommendations:
            "عامل کلیدی: خلاقیت در طراحی، ساخت باکیفیت، تحویل به موقع.<br>توصیه استراتژیک: ارائه پکیج کامل طراحی، ساخت و جمع‌آوری غرفه، دغدغه‌های شرکت‌کنندگان در نمایشگاه را برطرف می‌کند.",
    },
    {
        ParentID: 13,
        ParentTitle: "معماری داخلی و دکوراسیون",
        childid: 1129,
        ChildTitle: "اقلام و تجهیزات متفرقه",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "بر اساس نیاز",
        recommendedPhaseForBuy: "بر اساس نیاز",
        recommendedPhaseForExecution: "بر اساس نیاز",
        generalRecommendations:
            "عامل کلیدی: در دسترس بودن، قیمت مناسب.<br>توصیه استراتژیک: تبدیل شدن به یک منبع تأمین قابل اعتماد برای اقلامی که به سختی پیدا می‌شوند.",
    },
    {
        ParentID: 14,
        ParentTitle: "محوطه‌سازی و فضای سبز",
        childid: 1130,
        ChildTitle: "طراحی و اجرای فضای سبز",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "ظریف‌کاری",
        recommendedPhaseForBuy: "ظریف‌کاری",
        recommendedPhaseForExecution: "پایان کار",
        generalRecommendations:
            "عامل کلیدی: طراحی خلاقانه، انتخاب گیاهان مناسب با اقلیم، اجرای باکیفیت.<br>توصیه استراتژیک: ارائه پکیج کامل طراحی، اجرا و نگهداری، شما را به یک شریک بلندمدت تبدیل می‌کند.",
    },
    {
        ParentID: 14,
        ParentTitle: "محوطه‌سازی و فضای سبز",
        childid: 1131,
        ChildTitle: "کف‌سازی محوطه (سنگفرش، واش‌بتن)",
        saleType: "هر دو",
        recommendedPhaseForSale: "نازک‌کاری",
        recommendedPhaseForBuy: "ظریف‌کاری",
        recommendedPhaseForExecution: "پایان کار",
        generalRecommendations:
            "عامل کلیدی: زیبایی، دوام و مقاومت، اجرای دقیق با شیب‌بندی مناسب.<br>توصیه استراتژیک: ارائه طرح‌های متنوع و خلاقانه برای کف‌سازی، می‌تواند به هویت‌بخشی به محوطه کمک کند.",
    },
    {
        ParentID: 14,
        ParentTitle: "محوطه‌سازی و فضای سبز",
        childid: 1132,
        ChildTitle: "سیستم‌های آبیاری",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "ظریف‌کاری",
        recommendedPhaseForBuy: "ظریف‌کاری",
        recommendedPhaseForExecution: "پایان کار",
        generalRecommendations:
            "عامل کلیدی: طراحی بهینه برای کاهش مصرف آب، استفاده از تجهیزات باکیفیت.<br>توصیه استراتژیک: ارائه سیستم‌های هوشمند که بر اساس رطوبت خاک و آب و هوا کار می‌کنند، یک مزیت رقابتی قوی است.",
    },
    {
        ParentID: 14,
        ParentTitle: "محوطه‌سازی و فضای سبز",
        childid: 1133,
        ChildTitle: "مبلمان شهری و پارکی",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "ظریف‌کاری",
        recommendedPhaseForBuy: "ظریف‌کاری",
        recommendedPhaseForExecution: "پایان کار",
        generalRecommendations:
            "عامل کلیدی: طراحی زیبا، دوام و مقاومت در برابر شرایط جوی.<br>توصیه استراتژیک: ارائه محصولاتی با طراحی منحصربه‌فرد و کیفیت بالا برای پروژه‌های لوکس.",
    },
    {
        ParentID: 14,
        ParentTitle: "محوطه‌سازی و فضای سبز",
        childid: 1134,
        ChildTitle: "آلاچیق، پرگولا و سایبان",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "ظریف‌کاری",
        recommendedPhaseForBuy: "ظریف‌کاری",
        recommendedPhaseForExecution: "پایان کار",
        generalRecommendations:
            "عامل کلیدی: طراحی متناسب با فضا، کیفیت ساخت، دوام.<br>توصیه استراتژیک: ارائه طرح‌های سفارشی و استفاده از متریال‌های نوین، شما را از تولیدکنندگان انبوه متمایز می‌کند.",
    },
    {
        ParentID: 14,
        ParentTitle: "محوطه‌سازی و فضای سبز",
        childid: 1135,
        ChildTitle: "طراحی و اجرای روف گاردن",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "نازک‌کاری",
        recommendedPhaseForBuy: "ظریف‌کاری",
        recommendedPhaseForExecution: "پایان کار",
        generalRecommendations:
            "عامل کلیدی: طراحی خلاقانه، اجرای دقیق زیرساخت (ایزولاسیون، زه‌کشی)، انتخاب گیاهان مناسب.<br>توصیه استراتژیک: این یک کار کاملاً تخصصی است. تضمین آب‌بندی و ارائه یک فضای سبز پایدار و زیبا، کلید موفقیت است.",
    },
    {
        ParentID: 15,
        ParentTitle: "تجهیزات لابی و مشاعات",
        childid: 1136,
        ChildTitle: "تجهیزات خدماتی و نظافتی ( جاروی مرکزی،شوتینگ و ... )",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "دیوارچینی",
        recommendedPhaseForBuy: "گچ و خاک",
        recommendedPhaseForExecution: "نازک‌کاری",
        generalRecommendations:
            "عامل کلیدی: کیفیت و کارایی، نصب دقیق و استاندارد.<br>توصیه استراتژیک: نشان دادن مزایای بلندمدت این سیستم‌ها (رفاه، بهداشت) برای ترغیب سازنده به سرمایه‌گذاری اولیه.",
    },
    {
        ParentID: 15,
        ParentTitle: "تجهیزات لابی و مشاعات",
        childid: 1137,
        ChildTitle: "تجهیزات رفاهی و عمومی ( ورزشی،صوتی و ... )",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "ظریف‌کاری",
        recommendedPhaseForBuy: "ظریف‌کاری",
        recommendedPhaseForExecution: "پایان کار",
        generalRecommendations:
            "عامل کلیدی: برند معتبر، کیفیت و دوام، گارانتی.<br>توصیه استراتژیک: ارائه پکیج کامل تجهیزات برای فضاهای مشاع (مانند سالن ورزش یا اجتماعات)، کار را برای سازنده راحت می‌کند.",
    },
    {
        ParentID: 15,
        ParentTitle: "تجهیزات لابی و مشاعات",
        childid: 1138,
        ChildTitle: "تجهیزات پارکینگ",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "نازک‌کاری",
        recommendedPhaseForBuy: "ظریف‌کاری",
        recommendedPhaseForExecution: "ظریف‌کاری",
        generalRecommendations:
            "عامل کلیدی: کیفیت و دوام (مانند استاپر و محافظ ستون).<br>توصیه استراتژیک: ارائه راه‌حل‌های کامل برای مدیریت پارکینگ (مانند سیستم‌های هوشمند)، ارزش افزوده ایجاد می‌کند.",
    },
    {
        ParentID: 15,
        ParentTitle: "تجهیزات لابی و مشاعات",
        childid: 1139,
        ChildTitle: "تجهیزات لابی",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "ظریف‌کاری",
        recommendedPhaseForBuy: "ظریف‌کاری",
        recommendedPhaseForExecution: "پایان کار",
        generalRecommendations:
            "عامل کلیدی: طراحی لوکس و هماهنگ با معماری، کیفیت ساخت.<br>توصیه استراتژیک: همکاری با طراح داخلی پروژه برای ارائه یک پکیج کامل (لابی‌من، مبلمان، روشنایی).",
    },
    {
        ParentID: 15,
        ParentTitle: "تجهیزات لابی و مشاعات",
        childid: 1140,
        ChildTitle: "تجهیزات مخصوص معلولین",
        saleType: "هر دو",
        recommendedPhaseForSale: "نازک‌کاری",
        recommendedPhaseForBuy: "ظریف‌کاری",
        recommendedPhaseForExecution: "ظریف‌کاری",
        generalRecommendations:
            "عامل کلیدی: رعایت استانداردها و ضوابط، کیفیت و ایمنی.<br>توصیه استراتژیک: با توجه به الزامات جدید شهرداری، ارائه مشاوره و تأمین تجهیزات استاندارد، یک نیاز قطعی برای سازندگان است.",
    },
    {
        ParentID: 15,
        ParentTitle: "تجهیزات لابی و مشاعات",
        childid: 1141,
        ChildTitle: "مشاعات ساختمان",
        saleType: "-",
        recommendedPhaseForSale: "-",
        recommendedPhaseForBuy: "-",
        recommendedPhaseForExecution: "-",
        generalRecommendations:
            "(این عنوان یک دسته کلی است و تحلیل مشخصی ندارد)",
    },
    {
        ParentID: 15,
        ParentTitle: "تجهیزات لابی و مشاعات",
        childid: 1142,
        ChildTitle: "تجهیزات پزشکی",
        saleType: "سفارش‌گذاری",
        recommendedPhaseForSale: "ظریف‌کاری",
        recommendedPhaseForBuy: "ظریف‌کاری",
        recommendedPhaseForExecution: "پایان کار",
        generalRecommendations:
            "عامل کلیدی: استاندارد، برند معتبر، دقت.<br>توصیه استراتژیک: تمرکز بر تجهیزات عمومی مورد نیاز در ساختمان‌ها (مانند جعبه کمک‌های اولیه یا دستگاه AED).",
    },
    {
        ParentID: 16,
        ParentTitle: "املاک و مستغلات",
        childid: 1143,
        ChildTitle: "خرید و فروش املاک",
        saleType: "سفارشی‌سازی",
        recommendedPhaseForSale: "پایان کار",
        recommendedPhaseForBuy: "پایان کار",
        recommendedPhaseForExecution: "بعد از پایان کار",
        generalRecommendations:
            "عامل کلیدی: شبکه ارتباطی قوی، تخصص در بازاریابی و فروش، صداقت.<br>توصیه استراتژیک: تمرکز بر فروش انحصاری واحدهای یک پروژه و ارائه یک برنامه بازاریابی مدون، شما را به شریک فروش سازنده تبدیل می‌کند.",
    },
    {
        ParentID: 17,
        ParentTitle: "سایر",
        childid: 1144,
        ChildTitle: "سایر",
        saleType: "-",
        recommendedPhaseForSale: "-",
        recommendedPhaseForBuy: "-",
        recommendedPhaseForExecution: "-",
        generalRecommendations:
            "(این عنوان یک دسته کلی است و تحلیل مشخصی ندارد)",
    },
];
